import { AnyAction } from "redux";
import { FindById, Update } from "../../../searchers";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { Adapter } from "../../../../shared/adapter";
import { SearchersAdapter } from "../../../../adapter/searchers-adapter";

export const FETCH_UPDATE_SEARCHER_REQUEST = 'FETCH_UPDATE_SEARCHER_REQUEST';
export const FETCH_UPDATE_SEARCHER_SUCCESS = 'FETCH_UPDATE_SEARCHER_SUCCESS';
export const FETCH_UPDATE_SEARCHER_FAILURE = 'FETCH_UPDATE_SEARCHER_FAILURE';
export const SET_UPDATE_SEARCHER = 'SET_UPDATE_SEARCHER';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchUpdateSearcherRequest = () => {
    return {
        type: FETCH_UPDATE_SEARCHER_REQUEST,
    };
};

const fetchUpdateSearcherSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_UPDATE_SEARCHER_SUCCESS,
        payload: data
    };
};

const fetchUpdateSearcherFailure = (error: any) => {
    return {
        type: FETCH_UPDATE_SEARCHER_FAILURE,
        payload: error,
    };
};

export const setUpdateSearcher = (data: any) => {
    return {
        type: SET_UPDATE_SEARCHER,
        payload: data,
    };
};

export const update = (id: string, data: any) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchUpdateSearcherRequest());
        try {
            const response = await Update(id, data);
            dispatch(fetchUpdateSearcherSuccess(
                Adapter.from(response.data).to((value) => new SearchersAdapter(value).adapt())
            ));
        } catch (error: any) {
            dispatch(fetchUpdateSearcherFailure(error.message));
        }
    };
};

export const findById = (id: string) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchUpdateSearcherRequest());
        try {
            const response = await FindById(id, "fields=*.*");
            dispatch(setUpdateSearcher(
               response.data
            ));
        } catch (error: any) {
            dispatch(fetchUpdateSearcherFailure(error.message));
        }
    };
};
